import { Global, css } from '@emotion/react';
import { NextPageWithLayout } from '@scorenco/next';
import { useRouter } from 'next/router';

import { SponsorsSliderWidget } from '../../../components/Widgets';
import { WidgetsLayout } from '../../../layouts';

const SponsorsSlider: NextPageWithLayout = () => {
  const router = useRouter();
  const style = {
    globals: css`
      body {
        background: transparent;
      }
    `,
  };

  return (
    <>
      <Global styles={style.globals} />
      <SponsorsSliderWidget clubId={Number(router.query?.clubId)} />
    </>
  );
};

export const getStaticPaths = WidgetsLayout.buildGetStaticPaths();

export const getStaticProps = WidgetsLayout.buildGetStaticProps({
  i18n: { namespaces: ['common'] },
});

SponsorsSlider.getLayout = WidgetsLayout.buildGetLayout();

export default SponsorsSlider;
